import { ipgAllPaymentId } from "@/assets/googleTrackIds";
import { getCorrectDate, useAppSelector, useAppTranslation } from "@/utils";
import { CuToman, InfoCircleOutlined } from "@payping/icons";
import { reportApis } from "@payping/api";
import { moment } from "@payping/utils/dateUtils";
import { formatLocalizedNumber } from "@payping/utilities-shared/number";
import {
  Button,
  Flex,
  LegacyCard,
  Tooltip,
  Typography,
  useMessagedAsyncRetry,
  usePaypingContext,
} from "@payping/web-components";
import { Link } from "react-router-dom";
import { DashboardRoutes } from "@/router";

type Props = {
  isLoading: boolean;
};
const PaymentCard = ({ isLoading }: Props) => {
  const { t } = useAppTranslation();
  const { breakpoints } = usePaypingContext();
  const { md } = breakpoints;

  const lastWithdraw = useAppSelector((state) => state.user.overview.lastWithdraw);

  const balance = useAppSelector((state) => state.withdraws.balance);

  const fromDateFromTransactions = lastWithdraw ? getCorrectDate(lastWithdraw.reqDate) : undefined;

  const { loading: transactionsListLoading, value: transactions } = useMessagedAsyncRetry(
    () => reportApis.reportTransactionReport({ fromDate: fromDateFromTransactions }),
    [fromDateFromTransactions],
    {
      success: false,
    },
  );

  if (isLoading || transactionsListLoading) return null;

  return (
    <LegacyCard.Ant className="tw:w-full">
      <Flex gap={16} vertical={!md}>
        <Flex vertical gap="8px" className="tw:w-full">
          <Flex align="center">
            <Typography.Title className="tw:m-0!" level={4}>
              {`${formatLocalizedNumber({ value: balance, options: { maximumFractionDigits: 2 } })}`}
            </Typography.Title>
            <CuToman width={24} height={24} />
          </Flex>
          <Typography.Text>{t("overview.paymentCard.holding")}</Typography.Text>

          <Flex align="center" className="tw:mt-4!" gap="8px">
            <Tooltip
              className={"color--gray500 tw:flex tw:cursor-pointer tw:justify-between"}
              placement={"topLeft"}
              overlay={t("overview.paymentCard.tooltipInfo")}
            >
              {fromDateFromTransactions ? (
                <>
                  {t("overview.paymentCard.lastWithdraw", {
                    date: new Intl.DateTimeFormat("fa-IR", { dateStyle: "long" }).format(
                      moment(fromDateFromTransactions).toDate(),
                    ),
                  })}
                  <div className={"color--black tw:pr-1"}>
                    <InfoCircleOutlined width={"16px"} />
                  </div>
                </>
              ) : null}
            </Tooltip>
          </Flex>
        </Flex>
        {/* < موجودی درگاه پرداخت /> */}

        {/* < تعداد پرداخت موفق > */}
        <Flex vertical gap="8px" className="tw:w-full">
          {/* < تایتل > */}
          <Flex gap="8px">
            {transactions ? (
              <Typography.Title className="tw:m-0!" level={4}>
                {t("overview.paymentCard.transactionCount", { count: transactions.length })}
              </Typography.Title>
            ) : null}
          </Flex>

          {/* < متن > */}
          <Typography.Text>{t("overview.paymentCard.paymentFromLastSettlement")}</Typography.Text>

          {/* < لینک > */}
          <Link to={DashboardRoutes.mySale.report.url} className="tw:mt-4!" data-google-track={ipgAllPaymentId}>
            <Button>{t("overview.paymentCard.showAllPayments")}</Button>
          </Link>
        </Flex>
        {/* < تعداد پرداخت موفق /> */}
      </Flex>
    </LegacyCard.Ant>
  );
};

export default PaymentCard;
